import Datepicker from 'vuejs-datepicker'
import { ja } from 'vuejs-datepicker/dist/locale'
import moment from 'moment'

export default {
	name: 'DateSelect',
	components: {
		Datepicker
	},
	props: {
		value: String,
		min: String,
		max: String
	},
	data () {
		return {
			val: this.value,
			ja
		}
	},
	template: `
	<Datepicker
		v-model="val"
		@input="fireInput"
		@click.native="$emit('controlClick')"
		:disabled-dates="disabledDates"
		:language="ja"
		format="yyyy/MM/dd"
		class="m-sch__datewrap"
		input-class="m-sch__input"
		maximum-view="day"
	/>
	`,
	methods: {
		fireInput () {
			this.$emit('input', this.format(this.val))
		},
		/**
		 * @param Date date
		 * @returns String
		 */
		format (date) {
			if (!date instanceof Date) return ''
			return [
				date.getFullYear(),
				String(date.getMonth() + 1).padStart(2, '0'),
				String(date.getDate()).padStart(2, '0')
			].join('-')
		}
	},
	computed: {
		disabledDates () {
			const today = moment({ hour: 0, minute: 0, second: 0 })
			const dates = {
				to: today.toDate()
			}
			if (this.min) {
				dates.to = moment(this.min).toDate()
			}
			if (this.max) {
				dates.from = moment(this.max).add(1, 'days').toDate()
			}
			return dates
		}
	},
	watch: {
		value () {
			this.val = this.value
		}
	}
}
